import { RectangleLoader } from "../../../shared";

const Loader = () => {
    return (
        <RectangleLoader
            width="100%"
            height={8}
            isWaveAnimation
            customStyle={{ margin: "4px 0" }}
        />
    );
};

export default Loader;
